(function () {
  function refreshDrawer() {
    if (window.EBCartDrawerRefresh) return window.EBCartDrawerRefresh.refresh();
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  if (!customElements.get('cart-discount')) {
    customElements.define(
      'cart-discount',
      class extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('[data-cart-discount-input]');
          this.submit = this.querySelector('[data-cart-discount-submit]');
          this.message = this.querySelector('[data-cart-discount-message]');
          if (!this.input || !this.submit) return;

          this.submit.addEventListener('click', this.onSubmit.bind(this));
          this.input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              this.onSubmit();
            }
          });
        }

        showMessage(text, isError) {
          if (!this.message) return;
          this.message.textContent = text;
          this.message.hidden = !text;
          this.message.classList.toggle('is-error', !!isError);
        }

        onSubmit() {
          var code = (this.input.value || '').trim();
          if (!code) {
            this.showMessage('Enter a discount code.', true);
            return;
          }
          this.submit.classList.add('is-loading');
          this.submit.disabled = true;
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ discount: code })
          })
            .then((r) => r.json().then((body) => ({ ok: r.ok, body: body })))
            .then((res) => {
              if (!res.ok) {
                this.showMessage(
                  (res.body && res.body.description) || 'That code is not valid.',
                  true
                );
                return;
              }
              this.showMessage('');
              this.input.value = '';
              refreshDrawer();
            })
            .catch(() => {
              this.showMessage('Something went wrong. Try again.', true);
            })
            .finally(() => {
              this.submit.classList.remove('is-loading');
              this.submit.disabled = false;
            });
        }
      }
    );
  }
})();
